<template>
    <div class="notice" :class="{'success':type=='success','warning':type=='warning','error':type=='error'}">
      <!-- <p class="icons">
        <span class="iconfont icon-check"></span>
      </p> -->
      <p class="infos">
        <slot name="noticeTxt" />
      </p>
    </div>
</template>

<script>
export default {
  name: 'notice',
  props: {
    msg: String,
    type:String
  },
  data(){
    return{
    }
  }
}
</script>
<style scoped >
  
</style>